import React from 'react';
import { Row, Col } from 'react-bootstrap';
import WebpImage from '../webp-image';
import './style.css';

const seenImages = [
  { image: 'seenBump', alt: 'As seen in The Bump' },
  { image: 'seenScarymommy', alt: 'As seen in Scary Mommy' },
  { image: 'seenPregnancyandnewborn', alt: 'seen in Pregnancy and Newborn' },
  { image: 'seenInStyle', alt: 'As seen in InStyle' },
  { image: 'seenWhattoexpect', alt: 'As seen in What To Expect' },
  { image: 'seenBuzzfeed', alt: 'As seen in BuzzFeed' },
  {
    image: 'seenProjectNursery',
    alt: 'As seen in Project Nursery',
    hideFromMobile: true,
  },
];

const AsSeenIn = () => (
  <Row>
    <Col className='asSeenIn'>
      <h2>As Seen In</h2>
      {seenImages.map((images) => (
        <div
          key={images.image}
          className={
            !images.hideFromMobile ? 'asSeenInContainer' : 'hideFromMobile'
          }
        >
          <WebpImage
            imageName={images.image}
            alt={images.alt}
            width='43'
            height='60'
          />
        </div>
      ))}
    </Col>
  </Row>
);

export default React.memo(AsSeenIn);
